import { createWebHistory, createRouter } from "vue-router";
import Landing from "@/pages/Landing.vue";
import { useStorage } from "@/composables/use-storage";
import Status from "@/pages/Status.vue";
import Maintenance from "@/pages/status/503.vue";
import SendUsAMessage from "@/pages/email/send-us-a-message.vue";
import BaseLayout from "@/layouts/BaseLayout.vue";
import CompositeStem from "@/pages/benchmarks/CompositeStem.vue";
import ToU from "@/pages/legal/ToU.vue";
import Privacy from "@/pages/legal/Privacy.vue";
import Cookies from "@/pages/legal/Cookies.vue";
import { useAnalytics } from "@/composables/use-analytics";
import { handleMarketplaceUrl } from "@/services/api";

const { pageview } = useAnalytics();
const { userInfo } = useStorage();

function isAuthenticated() {
  return userInfo.value !== null && userInfo.value !== undefined;
}

function isAdmin() {
  return userInfo.value?.is_admin === true;
}

const routes = [
  {
    path: '/status',
    name: 'status',
    component: Status,
  },
  {
    path: '/status/503',
    name: '503',
    component: Maintenance,
  },
  {
    path: "/",
    name: "landing",
    component: Landing,
  },
  {
    path: "/composite",
    alias: ["/benchmarks/composite-stem"],
    name: "composite-stem",
    component: CompositeStem,
  },
  {
    path: '/',
    name: 'base',
    component: BaseLayout,
    children: [
    {
      path: '/status',
      name: 'status',
      component: Status,
    },
    {
      path: '/send-us-a-message',
      name: 'send-us-a-message',
      component: SendUsAMessage,
    },
    {
      path: '/status/503',
      name: '503',
      component: Maintenance,
    },
    {
      path: "/",
      name: "landing",
      component: Landing,
    },
    {
      path: '/tou',
      name: 'tou',
      component: ToU,
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy,
    },
    {
      path: '/cookies',
      name: 'cookies',
      component: Cookies,
    },
    ]
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { top: 0, behavior: 'smooth' };
  },
});

const verifyHasPermissions = (permissions) => {
  if (!Array.isArray(permissions)) {
    permissions = [permissions];
  }
  return permissions.some(permission => userInfo.value?.permissions.includes(permission));
};

router.beforeEach(async (to, from, next) => {
  if (!to.path.includes('status')) {
    pageview(window.location.href);
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated()) {
      next({ name: 'landing' }); // Redirect to login if not authenticated
    } else if (to.matched.some(record => record.meta.requiresAdmin) && !isAdmin()) {
      window.location.href = handleMarketplaceUrl() + '/'; // Redirect to explore if not admin
    } else if (to.matched.some(record => record.meta.permissions && !verifyHasPermissions(record.meta.permissions)) ) {
      window.location.href = handleMarketplaceUrl() + '/'; // Redirect to explore if not has permission
    } else {
      next(); // Proceed to the requested page
    }
  } else {
    next(); 
  }
});

export default router;
